import React, { Component } from "react";
import { ButtonGroup, Button } from "../../components";
import { multiLanguage } from "../../hoc";
import SitePlanImage from "../../data/PhuketDusitDeluxePoolVilla/sitePlan/svg";

@multiLanguage()
export default class Siteplan extends Component {
  state = {
    type: "all"
  };
  render() {
    const { t, dataSitePlan, currentLanguage, page } = this.props;
    const { type } = this.state;
    return (
      <div className={`section-siteplan ${page} site-plan-has-menu`}>
        <SitePlanImage currentLang={currentLanguage} selectedType={type} width={2500} height={1100} />
        <div className="siteplan-container-buttongroup">
          <ButtonGroup
            value={type}
            items={dataSitePlan}
            onChange={value => this.setState({ type: value })}
            direction="horizontal"
            renderItem={({ value, title, active, onClick }) => {
              return (
                <Button
                  key={value}
                  type="secondary"
                  active={active}
                  activeStyle={{ backgroundColor: "#00a9a5" }}
                  hoverStyle={{ backgroundColor: "#00a9a5" }}
                  defaultStyle={{
                    marginRight: "1px",
                    textTransform: "uppercase"
                  }}
                  onClick={onClick}
                >
                  {t(title)}
                </Button>
              );
            }}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/PhuketDusitDeluxePoolVilla/Siteplan.js